import { combineMultipleReducers, combineReducers } from "@client/lib/misc";
import { reducers as commonReducers } from "@client/reducers";
import { type FunnelInfoAppState, type GenericMap } from "@client/types";
import { type EventsAppState } from "@client/types/AppState/event";
import { type ViewerAppState } from "./types";

export const createReducer = (dynamicReducers: GenericMap<any> = {}) =>
  combineReducers<ViewerAppState>({
    ...commonReducers,
    ...combineMultipleReducers(dynamicReducers),
    events: (state: EventsAppState) => ({
      activeEventId: null,
      items: []
    }),
    funnelInfo: (state: FunnelInfoAppState | null = null) => state
  });

export const DEFAULT_DYNAMIC_REDUCERS = {
  modules: {}
};
